import { render, staticRenderFns } from "./转出项目商品详细_辉县版本.vue?vue&type=template&id=2683ed7e&scoped=true"
import script from "./转出项目商品详细_辉县版本.vue?vue&type=script&lang=js"
export * from "./转出项目商品详细_辉县版本.vue?vue&type=script&lang=js"
import style0 from "./转出项目商品详细_辉县版本.vue?vue&type=style&index=0&id=2683ed7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683ed7e",
  null
  
)

export default component.exports